module.exports = __webpack_public_path__ + "media/images/method-international_transfer-2e6cc263ecc4f7783d7747b9146e4090.png";